//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name:'headerbar',
		data(){
			return{
				showMenuBox:false,
				selectShow:false,
			}
		},
		props:{
			title:{//标题
				type:String,
				default:'E宠国际'
			},
			showHeader:{//是否显示headerbar
				type:Boolean,
				default:true
			},
			isFixed:{//headerbar是否固定在顶部
				type:Boolean,
				default:false
			},		
			noRefresh:{//headerbar返回是否进行刷新
				type:Boolean,
				default:false//刷新
			},
			storeShow:{
				type:Boolean,
				default:false
			}
		},
		methods:{
			icon_click(){
				console.log(111)
				this.selectShow=!this.selectShow;
			},
			backNoRefresh(){//自定义返回方法
          		this.$emit('backNoRefresh');/*获取父组件的方法*/
			},		
			back(){//返回并刷新
				// this.$router ? this.$router.back() : window.history.back()
				 window.history.back();
			},
			backFun(){
				if(this.noRefresh){
					this.backNoRefresh();
				}else{
					this.back();
				}
			},
			showMenu(){
				this.showMenuBox = !this.showMenuBox;
			},
			hideMenu(){
				this.showMenuBox = false;
			},
			go_bindshop(){
				this.$router.push({name:'alliance_bindshop'})
			},
			go_store(){
				this.$router.push({name:'alliance_store'})
			}
		},
		computed:{
			cartNum(){
				return this.$store.state.cartNum
			}
		}
	}
